/**
 * Contains general utility methods.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class GeneralUtility {
    /**
     * Gets the current page URL without any parameters or hashes.
     *
     * @returns {string} Current URL without a trailing slash
     */
    static getUrl() {
        let href = window.location.href;
        href = href.split('?')[0];
        href = href.split('#')[0];
        const length = href.length;
        if (href.charAt(length - 1) === '/') {
            href = href.substring(0, length - 1);
        }
        return href;
    }
}
